export const ZEROSIX_ERRORS = {
  INVALID_CARD: 'ZEROSIX_ERRORS.INVALID_CARD',
  CARD_EXPIRED: 'ZEROSIX_ERRORS.CARD_EXPIRED',
  INSUFFICIENT_FUNDS: 'ZEROSIX_ERRORS.INSUFFICIENT_FUNDS',
  TRANSACTION_DECLINED: 'ZEROSIX_ERRORS.TRANSACTION_DECLINED',
  NETWORK_ERROR: 'ZEROSIX_ERRORS.NETWORK_ERROR',
  UNKNOWN_ERROR: 'ZEROSIX_ERRORS.UNKNOWN_ERROR',
  AUTHENTIFICATION_FAILED: 'ZEROSIX_ERRORS.AUTHENTIFICATION_FAILED',
  CARD_ID_NOT_FOUND_IN_CARD_URL: 'ZEROSIX_ERRORS.CARD_ID_NOT_FOUND_IN_CARD_URL',
  INVALID_DATA: 'ZEROSIX_ERRORS.INVALID_DATA',
  INVALID_OTP_MESSAGE: 'ZEROSIX_ERRORS.INVALID_OTP_MESSAGE',
  MARKETPLACE_NOT_FOUND: 'ZEROSIX_ERRORS.MARKETPLACE_NOT_FOUND',
  NO_IDENTIICATION_CODE_RECEIVED: 'ZEROSIX_ERRORS.NO_IDENTIICATION_CODE_RECEIVED',
  NO_PHONE_NUMBER_RECEIVED: 'ZEROSIX_ERRORS.NO_PHONE_NUMBER_RECEIVED',
  PHONE_NUMBER_ALREADY_IN_USE_MESSAGE: 'ZEROSIX_ERRORS.PHONE_NUMBER_ALREADY_IN_USE_MESSAGE',
  PHONE_NUMBER_IS_EMPTY: 'ZEROSIX_ERRORS.PHONE_NUMBER_IS_EMPTY',
  PHONE_NUMBER_IS_UNKNOWN: 'ZEROSIX_ERRORS.PHONE_NUMBER_IS_UNKNOWN',
  PHONE_NUMBER_NOT_HANDLED_BY_ZEROSIX: 'ZEROSIX_ERRORS.PHONE_NUMBER_NOT_HANDLED_BY_ZEROSIX',
  PLUGIN_IS_DISABLED: 'ZEROSIX_ERRORS.PLUGIN_IS_DISABLED',
  PLUGIN_NOT_FOUND: 'ZEROSIX_ERRORS.PLUGIN_NOT_FOUND',
  SHOP_NOT_FOUND: 'ZEROSIX_ERRORS.SHOP_NOT_FOUND',
  USER_IS_NOT_ATTACHED_TO_MARKETPLACE_FOR_ZEROSIX:
    'ZEROSIX_ERRORS.USER_IS_NOT_ATTACHED_TO_MARKETPLACE_FOR_ZEROSIX',
  ZEROSIX_CARD_NOT_FOUND: 'ZEROSIX_ERRORS.ZEROSIX_CARD_NOT_FOUND',
  ZEROSIX_MEMBER_NOT_FOUND: 'ZEROSIX_ERRORS.ZEROSIX_MEMBER_NOT_FOUND',
} as const;

export type ZEROSIX_ERRORS = typeof ZEROSIX_ERRORS;
